import Keycloak from 'keycloak-js';
import log from 'loglevel';
import { omit } from 'remeda';

export default defineNuxtPlugin({
    name: 'keycloak-init',
    enforce: 'pre',
    hooks: {
        'app:created'() {
            const router = useRouter();
            const currentRoute = router.currentRoute.value;

            try {
                const query = omit(currentRoute.query, ['state', 'session_state', 'code']);
                router.replace({ query }).catch((err) => {
                    console.error('Navigation error:', err);
                });
            } catch (error) {
                console.error('Error during router.replace in keycloak-init:', error);
            }
        },
    },
    async setup() {
        try {
            const keycloak = new Keycloak({
                url: import.meta.env.VITE_API_KEYCLOAK_URL,
                realm: import.meta.env.VITE_API_KEYCLOAK_REALM,
                clientId: import.meta.env.VITE_API_KEYCLOAK_CLIENT_ID,
            });
            await keycloak.init({
                onLoad: 'check-sso',
                silentCheckSsoRedirectUri: useRelativeRoute('silent-check-sso.html'),
                responseMode: 'query',
                locale: 'en', // Set your desired language code here (e.g., 'en', 'cs', 'de', etc.)
            });

            const refreshInterval = 60000;
            setInterval(async () => {
                if (keycloak.authenticated && keycloak.token) {
                    if (keycloak.isTokenExpired(60)) {
                        try {
                            await keycloak.updateToken(60);
                        } catch (err) {
                            console.error('Failed to refresh token', err);
                        }
                    }
                }
            }, refreshInterval);

            const redirectToChangePassword = (locale = 'en') => {
                if (keycloak.authenticated) {
                    const redirectUri = encodeURIComponent(`${window.location.origin}/account`);
                    const updatePasswordUrl = `${keycloak.authServerUrl}/realms/${keycloak.realm}/protocol/openid-connect/auth?client_id=${keycloak.clientId}&redirect_uri=${redirectUri}&response_type=code&scope=openid&kc_action=UPDATE_PASSWORD&ui_locales=${locale}`;

                    window.location.href = updatePasswordUrl;
                } else {
                    console.error('User not authenticated.');
                }
            };

            return {
                provide: {
                    keycloak,
                    redirectToChangePassword,
                },
            };
        } catch (e) {
            log.error(e);
            throw createError({});
        }
    },
});
